export default {
    params: ['cids'],
    validate: (value, { cids }) => !cids.includes(value),
    message: (field) => `${field} não pode ser duplicado.`,
}